import React from "react";

import { VisitType } from "~/services";
import { ContactInfo } from "./ContactInfo";
import { MainContent } from "./MainContent";
import { VisitDetails } from "./VisitDetails";

type LeftPanelProps = {
  visitType: VisitType;
  handleGoBack: () => void;
};

export const LeftPanel = ({ visitType, handleGoBack }: LeftPanelProps) => {
  return (
    <div className="flex h-full flex-col">
      <div className="space-y-8">
        <MainContent visitType={visitType} handleGoBack={handleGoBack} />
        <VisitDetails visitType={visitType} />
        <ContactInfo />
      </div>
    </div>
  );
};
